<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";
import { usePreviewImg } from "@/use/common";
import { NodeViewProps } from "@tiptap/core";
import { NodeViewWrapper } from "@tiptap/vue-3";
import { Image } from "vant";
import { ref } from "vue";

const props = defineProps<NodeViewProps>();
const loading = ref(true);

const onImageClick = (url: string) => {
  useGlobalModal().openMediaPreviewModal([url]);
};
</script>
<template>
  <node-view-wrapper
    class="story-image"
    as="figure"
    @click="$event.stopPropagation()"
  >
    <Image
      v-show="!loading"
      fit="scale-down"
      :src="usePreviewImg(node.attrs.src)"
      @load="loading = false"
      @click="onImageClick(node.attrs.src)"
      crossorigin="anonymous"
    />
    <div
      v-if="loading"
      class="w-full h-[200px] flex items-center justify-center bg-neutral"
    >
      <span class="loading loading-sm"></span>
    </div>
  </node-view-wrapper>
</template>
<style>
.story-image {
  @apply w-full flex justify-center items-center;
}

.story-image .van-image {
  @apply rounded-lg overflow-hidden;
}

.story-image img {
  @apply max-h-[200px] m-0;
}

.tiptap[contenteditable="true"] .story-image.ProseMirror-selectednode {
  @apply bg-neutral border border-primary;
}
</style>
